import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Wrapper, CheckboxContainer, HiddenCheckbox, StyledCheckbox, Icon } from "./styled";
import { calSubTotal, setUrgent } from "../../../../../../../../../store/Concept/actions";
import { selectedArticles } from "../../../../../../../../../store/Concept/selectors";
import { isSelected } from "../../../../../../../../../utils/functions";

const Urgent = ({ row }) => {
  const dispatch = useDispatch();
  const selItems = useSelector(selectedArticles);
  const selected = isSelected(selItems, row.original.id);

  if (!row.original.inputs.showUrgent) {
    return null;
  }

  useEffect(() => {
    if (selected) {
      dispatch(calSubTotal(row.original.id));
    }
  }, [row.original.urgent]);

  return (
    <Wrapper isSelected={selected}>
      <CheckboxContainer checked={row.original.urgent} isSelected={selected}>
        <HiddenCheckbox checked={row.original.urgent} />
        <StyledCheckbox checked={row.original.urgent} onClick={() => dispatch(setUrgent(row))} isSelected={selected}>
          <Icon viewBox="0 0 24 24" isSelected={selected}>
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
    </Wrapper>
  );
};

export default Urgent;
